/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks
 * owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Card, Icon, Button, Divider, Grid } from '@scuf/common';
import { util } from '@keystone/common';
import { withApplicationContext, withCustomerSiteContext } from '../../common/HOCs';
import { getLicenseAPIVersion } from '../../common/APIClient';

const downloadStyle = {
  backgroundColor: '#84BD00',
  borderColor: '#84BD00',
  paddingTop: '.75rem',
  paddingRight: '1.5rem',
  paddingBottom: '.75rem',
  paddingLeft: '1.5rem',
  height: 'unset',
};

class DeviceConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCustomer: null,
    };
  }

  componentDidMount() {
    this.props.appContext.setNotification(null);
  }

  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12} sWidth={12}>
            <Card>
              <Card.Header title="Installation instructions for Android Devices">
                <a
                  onClick={() => null}
                  role="button"
                  className="ui small button primary"
                  style={downloadStyle}
                  href={`${util.getAPIGatewayURL()}/licenses/${getLicenseAPIVersion()}/customers/sentience/config/${
                    this.props.custSiteContext.selectedCustomer
                  }?id_token=${this.props.appContext.user.idToken}`}
                >
                  Download Config
                </a>
              </Card.Header>
              <Card.Content>
                <u>
                  <b>Installing from Windows:</b>
                </u>
                <br />
                If you are using the Windows file system, then follow the below instructions.
                <br />
                <ul>
                  <li>
                    Install the APK of the App you wish to license (please consult each Apps’
                    respective documentation for instructions).
                  </li>
                  <li>
                    Create directories if they do not exist (the “Configuration” folder under
                    “files” will need created manually in new installs).
                  </li>
                  <li>Unzip the Microservices.config from the downloaded folder.</li>
                  <li>
                    Move the Microservices.config file to the device’s directory:
                    "internalsharedstorage/Android/data/
                    <b>*defaultPackageName</b>
                    /files/configuration/Microservices.config"
                  </li>
                  <li>Shutdown the App and reboot the device.</li>
                  <li>
                    Start the App you initially installed and go into the home screen settings menu,
                    then select “settings” -> “Application Settings” and set the “Current
                    Application Scheme” to “Microservices”.
                  </li>
                  <li>
                    If successful, you will see the licensee’s name in the “Customer Name” field of
                    the “Application Settings” menu and the home screen will display “Application
                    Licensed”
                  </li>
                </ul>
                <br />
                Below is a list of the <b>*defaultPackageName</b> for each product currently using
                Enterprise Voice licensing:
                <br />
                <ul>
                  <li>
                    <b>DevKit</b>:- com.honeywell.GuidedWorkDemo
                  </li>
                  <li>
                    <b>D365</b>:- com.honeywell.Dynamics365
                  </li>
                  <li>
                    <b>SAP B1</b>:- com.honeywell.BusinessOne
                  </li>
                  <li>
                    <b>M&I</b>:- com.honeywell.sps.wfs.mandi
                  </li>
                  <li>
                    <b>VIO</b>:- com.honeywell.VIO
                  </li>
                </ul>
                <br />
                <u>
                  <b>ADB Install Instructions:</b>
                </u>
                <br />
                If you are using an <b>ADB</b> tool to push the config file to a device, run the
                below command.
                <ul>
                  <li>
                    adb push Microservices.config /sdcard/Android/data/
                    <b>*defaultPackageName</b>
                    /files/configuration/Microservices.config
                  </li>
                </ul>
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withApplicationContext(withCustomerSiteContext(DeviceConfig));
